import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface CargoRecord {

    id?: number;
    capacitacion_id?: number; 
    fecha_inicio?: Date;
    fecha_final?: Date;
    modalidad?: number | null;
    lugar?: string | null;
    url?: string | null;
    instructor?: string | null;
    observaciones?: string;
    estado?: number;

}

export interface CargoCapacitacion{

    id?: number;
    capacitacion_id: number; 
    fecha_inicio: Date;
    fecha_final: Date;
    modalidad: number | null;
    lugar: string | null;
    url: string | null;
    instructor: string | null;
    observaciones: string;
    estado: number;

}

@Injectable({
  providedIn: 'root'
})
export class CapacitacionProgramacionService {
  private apiUrl = `${environment.apiUrl}/api/capacitacion-programacion`;

  constructor(private http: HttpClient) {}

  getAllCapacitacionProgramacion(): Observable<any> {
    return this.http.get<any>(this.apiUrl, { withCredentials: true }).pipe(
      catchError(error => {
        console.error('Error al obtener cargos:', error);
        return throwError(() => error);
      })
    );
  }
  
    getAllCapacitacionProgramacionActivos(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/activos`, { withCredentials: true }).pipe(
      catchError(error => {
        console.error('Error al obtener cargos:', error);
        return throwError(() => error);
      })
    );
  }



  getCapacitacionProgramacionByIdAsistentes(id: string | number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/asistentes/${id}`, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }


  getCapacitacionProgramacionById(id: string | number): Observable<any> {
    
    return this.http.get<any>(`${this.apiUrl}/${id}`, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

    getCapacitacionFechas(id: string | number): Observable<any> {
    
    return this.http.get<any>(`${this.apiUrl}/fechas/${id}`, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  getCapacitacionProgramacionByIdPublica(id: string | number, tenantId:number): Observable<any> {
    console.log("cargando");
    return this.http.get<any>(`${this.apiUrl}/asistencia/${id}/${tenantId}`, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  createCapacitacionProgramacion(payload: CargoRecord): Observable<any> {
    return this.http.post<any>(this.apiUrl, payload, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  updateCapacitacionProgramacion(id: string | number, payload: CargoRecord): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, payload, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }


  activarCapacitacionProgramacion(id: string | number): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  inactivarCapacitacionProgramacion(id: string | number): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true }).pipe(
      catchError(error => throwError(() => error))
    );
  }

  getCapacitacionProgramacionActivos(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/activos`, { withCredentials: true }).pipe(
      catchError(error => {
        console.error('Error al obtener cargos:', error);
        return throwError(() => error);
      })
    );
  }
}